module.exports = __webpack_public_path__ + "img/logoBig.83fddc01.png";